module.exports = __webpack_public_path__ + "static/media/eyeOff.84c02d9f.svg";